import { render, staticRenderFns } from "./cModalDispacthDetails.vue?vue&type=template&id=f676be42"
import script from "./cModalDispacthDetails.vue?vue&type=script&lang=js"
export * from "./cModalDispacthDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports